import type { Rive } from '@rive-app/react-canvas';
import type { TFunction } from 'i18next';

import type { BannerToc } from '../../../../services/ui';
import { formatFinalPool } from '../../../Dialogs/TournamentDialog/ChampionsTournament/ChampionsBanner/buildBannerV6Values';

type Vm = NonNullable<Rive['viewModelInstance']>;

export interface TocLobbyBannerValues {
  finalPoolCc: string;
  finalPoolSc: string;
  currentRound: number;
  totalRounds: number;
}

/** The lobby banner's raw `toc` values as the file binds them: final pools in the coin formatting, rounds as-is. */
export function buildTocLobbyBannerValues(values: BannerToc, t: TFunction, language?: string): TocLobbyBannerValues {
  const { finalCc, finalSc } = formatFinalPool({ gcCoin: values.finalPoolGc, scCoin: values.finalPoolSc }, t, language);
  // Rounds left and trophies are derived by the file from these.
  return {
    finalPoolCc: finalCc,
    finalPoolSc: finalSc,
    currentRound: values.currentRound,
    totalRounds: values.totalRounds,
  };
}

// A property the file lacks reads as null: skipped silently.
export function bindTocLobbyBanner(vm: Vm, values: TocLobbyBannerValues) {
  const setString = (path: string, value: string) => {
    const prop = vm.string?.(path);
    if (prop) prop.value = value;
  };
  const setNumber = (path: string, value: number) => {
    const prop = vm.number?.(path);
    if (prop) prop.value = value;
  };
  setString('finalPoolCc', values.finalPoolCc);
  setString('finalPoolSc', values.finalPoolSc);
  setNumber('currentRound', values.currentRound);
  setNumber('totalRounds', values.totalRounds);
}
